import { LocalLessonProviderData } from "@jelly/lesson";
import lesson01 from "./lesson-01/lesson";
import lesson02 from "./lesson-02/lesson";
import lessonLinks02 from "./lesson-02/lessonLinks";
import lesson03 from "./lesson-03/lesson";
import lesson03Links from "./lesson-03/lessonLinks";
import lesson04 from "./lesson-04/lesson";
import lesson05 from "./lesson-05/lesson";
import lesson06 from "./lesson-06/lesson";
import lesson07 from "./lesson-07/lesson";
import lesson07Links from "./lesson-07/lessonLinks";
import lesson08 from "./lesson-08/lesson";
import lesson08Links from "./lesson-08/lessonLinks";
import lesson09 from "./lesson-09/lesson";
import lesson09Links from "./lesson-09/lessonLinks";
import lesson10 from "./lesson-10/lesson";
import lesson10Links from "./lesson-10/lessonLinks";
import lesson11 from "./lesson-11/lesson";
import lesson11Links from "./lesson-11/lessonLinks";
import lesson12 from "./lesson-12/lesson";
import lesson13 from "./lesson-13/lesson";
import lesson13Links from "./lesson-13/lessonLinks";
import lesson14 from "./lesson-14/lesson";
import lesson14Links from "./lesson-14/lessonLinks";
import lesson15 from "./lesson-15/lesson";
import lesson15Links from "./lesson-15/lessonLinks";
import lesson16 from "./lesson-16/lesson";
import lesson17 from "./lesson-17/lesson";
import lesson18 from "./lesson-18/lesson";
import lesson18Links from "./lesson-18/lessonLinks";
import lesson19 from "./lesson-19/lesson";
import lesson19Links from "./lesson-19/lessonLinks";
import lesson20 from "./lesson-20/lesson";
import lesson21 from "./lesson-21/lesson";
import lesson21Links from "./lesson-21/lessonLinks";
import lesson22 from "./lesson-22/lesson";
import lesson22Links from "./lesson-22/lessonLinks";
import lesson23 from "./lesson-23/lesson";
import lesson24 from "./lesson-24/lesson";
import lesson24Links from "./lesson-24/lessonLinks";
import lesson25 from "./lesson-25/lesson";
import lesson25Links from "./lesson-25/lessonLinks";
import lesson26 from "./lesson-26/lesson";
import lesson26Links from "./lesson-26/lessonLinks";
import lesson27 from "./lesson-27/lesson";
import lesson27Links from "./lesson-27/lessonLinks";
import lesson28 from "./lesson-28/lesson";
import lesson28Links from "./lesson-28/lessonLinks";
import lesson29 from "./lesson-29/lesson";
import lesson29Links from "./lesson-29/lessonLinks";
import lesson30 from "./lesson-30/lesson";
import lesson30Links from "./lesson-30/lessonLinks";
import case01 from "./case-01/case";

const data: LocalLessonProviderData = {
  byId: {
    [lesson01.id]: lesson01,
    [lesson02.id]: lesson02,
    [lesson03.id]: lesson03,
    [lesson04.id]: lesson04,
    [lesson05.id]: lesson05,
    [lesson06.id]: lesson06,
    [lesson07.id]: lesson07,
    [lesson08.id]: lesson08,
    [lesson09.id]: lesson09,
    [lesson10.id]: lesson10,
    [lesson11.id]: lesson11,
    [lesson12.id]: lesson12,
    [lesson13.id]: lesson13,
    [lesson14.id]: lesson14,
    [lesson15.id]: lesson15,
    [lesson16.id]: lesson16,
    [lesson17.id]: lesson17,
    [lesson18.id]: lesson18,
    [lesson19.id]: lesson19,
    [lesson20.id]: lesson20,
    [lesson21.id]: lesson21,
    [lesson22.id]: lesson22,
    [lesson23.id]: lesson23,
    [lesson24.id]: lesson24,
    [lesson25.id]: lesson25,
    [lesson26.id]: lesson26,
    [lesson27.id]: lesson27,
    [lesson28.id]: lesson28,
    [lesson29.id]: lesson29,
    [lesson30.id]: lesson30,
    [case01.id]: case01,
  },
  linksById: {
    [lesson01.id]: [],
    [lesson02.id]: lessonLinks02,
    [lesson03.id]: lesson03Links,
    [lesson04.id]: [],
    [lesson05.id]: [],
    [lesson06.id]: [],
    [lesson07.id]: lesson07Links,
    [lesson08.id]: lesson08Links,
    [lesson09.id]: lesson09Links,
    [lesson10.id]: lesson10Links,
    [lesson11.id]: lesson11Links,
    [lesson12.id]: [],
    [lesson13.id]: lesson13Links,
    [lesson14.id]: lesson14Links,
    [lesson15.id]: lesson15Links,
    [lesson16.id]: [],
    [lesson17.id]: [],
    [lesson18.id]: lesson18Links,
    [lesson19.id]: lesson19Links,
    [lesson20.id]: [],
    [lesson21.id]: lesson21Links,
    [lesson22.id]: lesson22Links,
    [lesson23.id]: [],
    [lesson24.id]: lesson24Links,
    [lesson25.id]: lesson25Links,
    [lesson26.id]: lesson26Links,
    [lesson27.id]: lesson27Links,
    [lesson28.id]: lesson28Links,
    [lesson29.id]: lesson29Links,
    [lesson30.id]: lesson30Links,
    [case01.id]: [],
  },
};

export default data;
